/**
 * 사업장 기본정보 컬럼 정의
 * PLA_BASIC 화면 전용 컬럼 정의
 */

import { CreateColumn } from '../../../../Services/agGrid/createColumn';

/**
 * 사업장정보 컬럼 정의 생성
 * @param {object} props - 컴포넌트 props
 * @returns {Array} 컬럼 정의 배열
 */
export const getColumnDefs1 = (props) => {
  return [
    // 체크박스 컬럼 (NO 컬럼)
    CreateColumn('no', 'NO', 'center', 80, false, false, false, 'checkbox', {
      checkboxProps: {
        DeleteNewRow: props.DeleteNewRow1,
        RestoreRow: props.RestoreRow,
        gridRef: props.gridRef1,
        rowData: props.rowData,
        selectedRowNosRef: props.selectedRowNosRef,
        lastCheckedIndexRef: props.lastCheckedIndexRef,
        handleRowSelection: props.handleRowSelection,
        dispatchGrid: props.dispatchGrid,
        gridState: props.gridState,
      },
      maxWidth: 80,
    }),
    // 숨김 컬럼
    CreateColumn('coCd', '회사코드', 'left', 150, false, false, true, 'text', {
      minWidth: 150,
      flex: 1,
    }),
    // 회사명 컬럼 (관리자만 표시)
    CreateColumn(
      'coNm',
      '회사명',
      'left',
      150,
      false,
      false,
      props.userInfo.authCd === 'ADMIN' ? false : true,
      'text',
      {
        minWidth: 150,
        flex: 1,
      }
    ),
    // 사업장명 컬럼
    CreateColumn(
      'custNm',
      '사업장명',
      'left',
      250,
      false,
      false,
      false,
      'text',
      {
        minWidth: 250,
        flex: 1,
      }
    ),
    // 대표자 컬럼
    CreateColumn('ceo', '대표자', 'left', 100, false, false, false, 'text', {
      minWidth: 100,
      flex: 1,
    }),
    // 사업자등록번호 컬럼
    CreateColumn(
      'businessNo',
      '사업자등록번호',
      'right',
      150,
      false,
      false,
      false,
      'businessNumber',
      {
        minWidth: 150,
        flex: 1,
      }
    ),
    // 사업자관리번호 컬럼
    CreateColumn(
      'businessMaNo',
      '사업자관리번호',
      'right',
      150,
      false,
      false,
      false,
      'text',
      {
        minWidth: 150,
        flex: 1,
      }
    ),
    // 사업개시번호 컬럼
    CreateColumn(
      'businessStartNo',
      '사업개시번호',
      'right',
      150,
      false,
      false,
      false,
      'text',
      {
        minWidth: 150,
        flex: 1,
      }
    ),
    // 업종코드 컬럼 (숨김)
    CreateColumn('indCd', '업종코드', 'left', 170, false, false, true, 'text', {
      minWidth: 170,
      flex: 1,
    }),
    // 업종(대분류) 컬럼
    CreateColumn(
      'industrialMain',
      '업종(대분류)',
      'left',
      200,
      false,
      false,
      false,
      'text',
      {
        minWidth: 200,
        flex: 1,
        tooltipField: 'industrialMain',
      }
    ),
    // 업종(중분류) 컬럼
    CreateColumn(
      'industrialSub',
      '업종(중분류)',
      'left',
      200,
      false,
      false,
      false,
      'text',
      {
        minWidth: 200,
        flex: 1,
        tooltipField: 'industrialSub',
      }
    ),
    // 업종(소분류) 컬럼
    CreateColumn(
      'industrialSmall',
      '업종(소분류)',
      'left',
      200,
      false,
      false,
      false,
      'text',
      {
        minWidth: 200,
        flex: 1,
        tooltipField: 'industrialSmall',
      }
    ),
    // 연락처 컬럼
    CreateColumn(
      'custTel',
      '연락처',
      'left',
      150,
      false,
      false,
      false,
      'text',
      {
        flex: 1,
      }
    ),
    // 팩스 컬럼
    CreateColumn('custFax', '팩스', 'left', 150, false, false, false, 'text', {
      flex: 1,
    }),
    // 소재지 컬럼
    CreateColumn(
      'location',
      '소재지',
      'left',
      150,
      false,
      false,
      false,
      'text',
      {
        minWidth: 150,
        flex: 1,
        tooltipField: 'location',
      }
    ),
    // 상시근로자수 컬럼
    CreateColumn(
      'workNo',
      '상시근로자수',
      'right',
      130,
      false,
      false,
      false,
      'text',
      {
        minWidth: 130,
        flex: 1,
      }
    ),
    // 수급업체수 컬럼
    CreateColumn(
      'mstNo',
      '수급업체수',
      'right',
      130,
      false,
      false,
      false,
      'text',
      {
        minWidth: 130,
        flex: 1,
      }
    ),
    // 사업장코드 컬럼 (숨김)
    CreateColumn(
      'custCd',
      '사업장코드',
      'left',
      100,
      false,
      false,
      true,
      'text',
      {
        minWidth: 100,
      }
    ),
  ];
};

/**
 * 업종 그리드 컬럼 정의 생성
 * @returns {Array} 컬럼 정의 배열
 */
export const getColumnDefs2 = () => {
  return [
    // 체크박스 컬럼 (NO 컬럼)
    CreateColumn('no', 'NO', 'right', 100, false, false, false, 'checkbox', {
      maxWidth: 100,
    }),
    // 산재업종_대분류 컬럼
    CreateColumn(
      'industrialMain',
      '산재업종_대분류',
      'left',
      200,
      false,
      false,
      false,
      'text',
      {
        minWidth: 200,
        tooltipField: 'industrialMain',
        flex: 1,
      }
    ),
    // 산재업종_중분류 컬럼
    CreateColumn(
      'industrialSub',
      '산재업종_중분류',
      'left',
      200,
      false,
      false,
      false,
      'text',
      {
        minWidth: 200,
        tooltipField: 'industrialSub',
      }
    ),
    // 산재업종_소분류 컬럼
    CreateColumn(
      'industrialSmall',
      '산재업종_소분류',
      'left',
      200,
      false,
      false,
      false,
      'text',
      {
        minWidth: 200,
        tooltipField: 'industrialSmall',
      }
    ),
    // 산재업종_세부작업 컬럼
    CreateColumn(
      'industrialDetail',
      '산재업종_세부작업',
      'left',
      200,
      false,
      false,
      false,
      'text',
      {
        minWidth: 200,
        tooltipField: 'industrialDetail',
      }
    ),
    // 표준산업_대분류 컬럼
    CreateColumn(
      'standardMain',
      '표준산업_대분류',
      'left',
      200,
      false,
      false,
      false,
      'text',
      {
        minWidth: 200,
        tooltipField: 'standardMain',
      }
    ),
    // 표준산업_중분류 컬럼
    CreateColumn(
      'standardSub',
      '표준산업_중분류',
      'left',
      200,
      false,
      false,
      false,
      'text',
      {
        minWidth: 200,
        tooltipField: 'standardSub',
      }
    ),
    // 표준산업_소분류 컬럼
    CreateColumn(
      'standardSmall',
      '표준산업_소분류',
      'left',
      200,
      false,
      false,
      false,
      'text',
      {
        minWidth: 200,
        tooltipField: 'standardSmall',
      }
    ),
  ];
};

/**
 * 관리자 관리 그리드 컬럼 정의 생성
 * @param {object} props - 컴포넌트 props
 * @returns {Array} 컬럼 정의 배열
 */
export const getColumnDefs3 = (props) => {
  return [
    // 관리자 ID 컬럼 (버튼 타입)
    CreateColumn(
      'cmId',
      '관리자 ID',
      'left',
      120,
      false,
      false,
      false,
      'requiredButton',
      {
        buttonClickHandler: (params) => {
          props.PopupClickEvent4(params);
        },
      }
    ),
    // 관리자명 컬럼
    CreateColumn('ceo', '관리자명', 'left', 200, false, false, false, 'text', {
      flex: 1,
    }),
    // 전화번호 컬럼
    CreateColumn(
      'cmTel',
      '전화번호',
      'center',
      150,
      false,
      false,
      false,
      'phone',
      {
        minWidth: 150,
      }
    ),
    // 생년월일 컬럼
    CreateColumn(
      'cmBirth',
      '생년월일',
      'center',
      150,
      false,
      false,
      false,
      'date',
      {
        minWidth: 150,
        flex: 1,
      }
    ),
  ];
};

/**
 * 관리자 관리 안 관리자ID 그리드 컬럼 정의 생성
 * @returns {Array} 컬럼 정의 배열
 */
export const getColumnDefs4 = () => {
  return [
    // 체크박스 컬럼 (NO 컬럼)
    CreateColumn('no', 'NO', 'right', 100, false, false, false, 'checkbox', {
      maxWidth: 100,
    }),
    // ID 컬럼
    CreateColumn('id', 'ID', 'left', 120, false, false, false, 'text', {
      flex: 1,
    }),
    // 이름 컬럼
    CreateColumn('ceo', '이름', 'left', 200, false, false, false, 'text', {
      flex: 1,
    }),
    // 전화번호 컬럼
    CreateColumn(
      'tel',
      '전화번호',
      'center',
      150,
      false,
      false,
      false,
      'phone',
      {
        minWidth: 150,
      }
    ),
    // 생년월일 컬럼
    CreateColumn(
      'birth',
      '생년월일',
      'center',
      150,
      false,
      false,
      false,
      'date',
      {
        minWidth: 150,
        flex: 1,
      }
    ),
  ];
};

const columnDefs = {
  getColumnDefs1,
  getColumnDefs2,
  getColumnDefs3,
  getColumnDefs4,
};

export default columnDefs;
